// Display formatters shared across the analytics views.
//
// Both started as private helpers inside AnalyticsPage and were promoted when the referee roster
// needed the identical rendering — two copies of "how do we show a rate" is how one table ends up
// rounding differently from the card above it.

// A 0–1 rate as a whole percent. null (no denominator) renders as an em dash, never 0% — "nobody
// has answered yet" and "everybody got it wrong" must not look the same.
export function pct(rate: number | null | undefined): string {
  return rate == null ? '—' : `${Math.round(rate * 100)}%`;
}

// Compact relative time ("3h ago", "2d ago"). Coarse buckets are deliberate: these read as an
// at-a-glance recency signal in a table, not as a precise timestamp.
export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return 'never';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

// An absolute, unambiguous date ("20 Aug 2026"). Used where recency is not the point and the exact
// day is — an exam sitting is a dated record, not a "3d ago" event.
export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
